import { NodeSelection, TextSelection, type EditorState, type Transaction } from '@tiptap/pm/state';

/**
 * Seçimi içeren üst düzey bloğu (paragraf, başlık, liste, tablo, görsel, video) bir üste veya alta taşır
 * (F5B-24, WCAG 2.2 — 2.5.7 sürükleme hareketleri: görsel/video sürüklenebilir; aynı iş tek tıkla da yapılır).
 * Taşınamazsa (ilk/son blok) null döner. Seçim taşınan blokla birlikte gider.
 */
export function moveBlock(state: EditorState, dir: -1 | 1): Transaction | null {
  const { doc, selection } = state;
  const index = selection.$from.index(0);
  // Seçim birden çok üst düzey bloğa yayılıyorsa taşınmaz (belirsiz).
  if (
    selection.$to.index(0) !== index &&
    !(selection.$to.depth === 0 && selection.$to.index(0) === index + 1)
  )
    return null;
  const target = index + dir;
  if (target < 0 || target >= doc.childCount) return null;
  let pos = 0;
  for (let i = 0; i < index; i++) pos += doc.child(i).nodeSize;
  const node = doc.child(index);
  const neighbour = doc.child(target);
  const newPos = dir === -1 ? pos - neighbour.nodeSize : pos + neighbour.nodeSize;
  const tr = state.tr.delete(pos, pos + node.nodeSize).insert(newPos, node);
  const shift = newPos - pos;
  if (selection instanceof NodeSelection)
    tr.setSelection(NodeSelection.create(tr.doc, selection.from + shift));
  else tr.setSelection(TextSelection.create(tr.doc, selection.anchor + shift, selection.head + shift));
  return tr.scrollIntoView();
}

/** Taşıma düğmelerinin etkinliği: seçimin bulunduğu bloğun üstünde/altında blok var mı. */
export function canMoveBlock(state: EditorState, dir: -1 | 1): boolean {
  const index = state.selection.$from.index(0);
  const target = index + dir;
  return target >= 0 && target < state.doc.childCount;
}
